import {
  actionName,
  roleName,
  type GameEvent,
  type LobbyView,
  type Theme,
} from '@betrayal/shared';

export function nameOf(lobby: LobbyView, id: string): string {
  return lobby.members.find((m) => m.id === id)?.name ?? id;
}

/** Render a public game event as human text through the active theme. */
export function eventText(e: GameEvent, theme: Theme, who: (id: string) => string): string {
  switch (e.type) {
    case 'game_started':
      return `The game begins: ${e.players.map(who).join(', ')}.`;
    case 'turn_started':
      return `— ${who(e.player)}'s turn —`;
    case 'action_declared':
      return `${who(e.player)} declares ${actionName(theme, e.action)}${e.target ? ` on ${who(e.target)}` : ''}.`;
    case 'block_declared':
      return `${who(e.player)} claims ${roleName(theme, e.role)} to block ${actionName(theme, e.action)}.`;
    case 'challenge_declared':
      return `${who(e.challenger)} challenges ${who(e.claimant)}'s claim of ${roleName(theme, e.role)}!`;
    case 'challenge_failed':
      return `${who(e.claimant)} reveals ${roleName(theme, e.role)} and returns it to the deck. The challenge fails.`;
    case 'challenge_succeeded':
      return `${who(e.claimant)} was bluffing — no ${roleName(theme, e.role)}.`;
    case 'card_lost':
      return `${who(e.player)} loses influence: ${roleName(theme, e.role)} is revealed.`;
    case 'player_eliminated':
      return `${who(e.player)} is out of the game.`;
    case 'action_resolved':
      return `${who(e.player)}'s ${actionName(theme, e.action)} resolves${
        e.amount !== undefined ? ` (+${e.amount} coin${e.amount === 1 ? '' : 's'})` : ''
      }${e.target ? ` against ${who(e.target)}` : ''}.`;
    case 'action_blocked':
      return `${who(e.blocker)} blocks ${who(e.player)}'s ${actionName(theme, e.action)}.`;
    case 'action_failed':
      return `${who(e.player)}'s ${actionName(theme, e.action)} fails.`;
    case 'exchange_completed':
      return `${who(e.player)} finishes trading with the deck.`;
    case 'timed_out':
      return `${who(e.player)} ran out of time.`;
    case 'game_over':
      return `👑 ${who(e.winner)} wins!`;
  }
}
